module.exports = __webpack_public_path__ + "media/unipod/icon-quality-c2c51520.svg";